import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
import PDFview from "../../../../components/PdfView";
const GatePassInList = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [gatepassId, setGatepassId] = useState(0);
  const [docurl, setDocUrl] = useState(false);
  const [itemsPerPage] = useState(10);


  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);



  const FillDetail = () => {
    getDataList(
      {
        url: `/api/gatePass/?gatepassType=In&orgId=${localStorage.getItem(
          "orgId"
        )}&&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setGatepassId(itemId);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.gatepassId;

    getDetailView(
      {
        url: `/api/gatePass/?orgId=${localStorage.getItem(
          "orgId"
        )}&gatepassId=${Id}`,
      },
      (res) => {
        //console.log("Detail View", res);
        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div>
          <h4 className="card-title">Gate Pass In Details</h4>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>

          {selectedData && (
            <div>
              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Date</label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getpassDate} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Field Officer </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.employeeName} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> GetPass No </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.docNo} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> InTime</label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.inTime} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Warehouse </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.fromWarehouseName} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Getpass Type</label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getpassType} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Getpass For </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getpassFor} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Farmer/Employee Name </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getPassForName} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Doc No For</label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.docNoFor} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Doc For Date </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.harvestDate} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Email Id </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.email} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Contact No </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.contactnumber} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Vehicle</label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.vehicle} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Vehicle Number </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.vehiclenumber} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Driver Name </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.vehicledrivername} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Driver Contact No </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.drivercontactnumber} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Load Quantity </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label>
                    {" "}
                    {selectedData.loadQuantity} {selectedData.unitAbbreviation}{" "}
                  </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Remark/Note </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.remarkNote} </label>{" "}
                </div>
              </div>
              <div className="row">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Product Type</th>
                      <th>Product Subtype</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData.productData &&
                      selectedData.productData.map((itm, i) => {
                        return (
                          <tr key={i} className="cursor-pointer">
                            <td>{i + 1}</td>
                            <td>{ itm.productId?  itm.productTypeName
                            :
                            itm.cropTypeName
                            } </td>
                            <td> { itm.productId? 
                            itm.productSubTypeName
                            :
                            itm.cropName
                            }</td> 

                            <td>{ itm.productId?  itm.productName
                              :
                              itm.varietyName
                              }</td>
                            <td>{itm.itemQuantity}</td>
                            <td>{itm.unitAbbreviation}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              {" "}
              &nbsp; &nbsp;Getpass-In Detail
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
          {canAdd === "block" && (
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Getpass-In
            </button>)}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Getpass Date</th>
                            <th>Getpass No</th>
                            <th>Gate Pass For</th>
                            <th>Person / Employee / Farmer</th>
                            <th>Assigned Supervisor</th>

                         
                            {canView === "block" && <th>View</th>}
                            {canPdf === "block" && <th>Pdf</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.getpassDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.getpassFor ?? "Procurement"}</td>

                                <td>{x.getPassForName}</td>

                                <td>{x.employeeName}</td>
                              

                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(x)}
                                    >
                                      {" "}
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                                {canPdf === "block" && (
                                  <td>
                                    {" "}
                                    <button
                                      className="btn"
                                      onClick={() => viewPdf(x.gatepassId)}
                                    >
                                      <i className="fas fa-solid fa-file"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {docurl && (
        <Modal isOpen={true} style={customModalStyles}>
          {gatepassId && (
            <div className="row">
              <div className="col-md-11">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}/api/gatepass_pdf/?gatepassId=${gatepassId}`,
                      "_blank"
                    )
                  }
                >
                  Download
                </button>
              </div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setDocUrl(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
          )}
          <PDFview
            docurl={`${process.env.REACT_APP_BASE_URL}/api/gatepass_pdf/?gatepassId=${gatepassId}`}
          />
        </Modal>
      )}
    </>
  );
};

export default GatePassInList;
